import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkb986aResCtrSearchresultDto } from 'sg-api';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sgkb713d',
  templateUrl: './sgkb713d.component.html',
  styleUrl: './sgkb713d.component.scss'
})
export class Sgkb713dComponent implements OnInit, OnDestroy {

  @Output() errorMessageModelArray: Array<SgAriaMessage>;
  /** 遷移元ステータス */
  @Output() mode : string;
  /** 包括契約検索APIレスポンス */
  @Output() ctrSearchresultList: Array<Sgkb986aResCtrSearchresultDto>;

  private onDestroy$ = new Subject();

  /** 検索条件フォームグループ */
  kensakuJyoukenForm: UntypedFormGroup;

  /** 検索結果表示フラグ */
  showResult: boolean = false;
  /** クリア押下フラグ */
  clearExeFlg: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) {
    this.kensakuJyoukenForm = this.fb.group({});

    // 画面遷移時のパラメータ取得
    // 遷移パラメータ  read：参照、create：登録、midterm_change：期中変更、
    //                renewal：契約更改、cancel：解約、approve：承認、delete：取消
    this.mode = this.route.snapshot.paramMap.get('mode');
  }

  /**
   * 初期処理
   * @memberof Sgkb713dComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.kensakuJyoukenForm.clearValidators();
    this.kensakuJyoukenForm.updateValueAndValidity();
    this.kensakuJyoukenForm.removeControl('kensakuJyoukenForm');
  }

  /**
   * 検索結果の行選択処理
   * @memberof Sgkb713dComponent
   */
  onClickRow(row): void {
    /** 包括割引契約登録画面への遷移 */
    this.router.navigate(['/sgkb/sgkb708d',{
      // 包括お客さま番号
      inclusioncontractVisitornumber: row.inclusioncontractVisitornumber || "",
      // 包括契約履歴番号
      inclusioncontractRrkno: row.inclusioncontractRrkno || "",
      // 包括契約年度内通番号
      inclusioncontractYearnaiSrno: row.inclusioncontractYearnaiSrno || "",
      // 包括契約登録操作コード
      mode: this.mode || ""
    }]);
  }

  /**
   * 検索条件コンポーネントからの受領値設定
   * @memberof Sgkb713dComponent
   */
  setValue(eventData: any): void {
    this.showResult = eventData.showResult;
    this.clearExeFlg = eventData.clearExeFlg;
    this.ctrSearchresultList = eventData.ctrSearchresultList;
  }
}
